
export const colors = {
    primary: '#0870b4',
    secondary: '#065a8a',
    hover: '#07619b',

    textPrimary: '#095d7e',
    textSecondary: '#065a8a',
    
    grayLight: '#gray-400',
    grayDark: '#gray-800'
};
